export default __webpack_public_path__ + "static/media/4-cheese.d3442460.png";